<template>
	<transition name='fade'>
		<div v-if='value||visiable' class="modal-container" @mousewheel.prevent @touchstart.prevent>
			<div class="modal-content">
				<slot name="title">
					<div class="title">
						<div v-html='title || inlineTitle'></div>
					</div>
				</slot>
				<div class="content">
					<slot name="content">
						<div v-html='content'></div>
					</slot>
				</div>
				<slot name="footer">
					<div class="footer">
						<span @click='makeSure' class="button">確定</span>
						<span v-if='type == "confirm"' @click='close' class="button">取消</span>
					</div>
				</slot>
				
			</div>

		</div>
	</transition>
	
</template>

<script>
	import {
		mapState,
		mapActions
	} from 'vuex'
	export default {
		name: 'Modal',
		data() {
			return {
				content:'',
				inlineTitle:'',
				onOk:null,
				onCancel:null,
				type:'alert',
				visiable:false,
			}
		},
		props:{
			value:{
				type:Boolean,
				default:false,
			},
			title:{
				type:String,
				default:'',
			},
		},
		created() {
			this.$nextTick(function() {
				this.initData()
			})
		},
		mounted() {

		},
		watch:{

		},
		mixins:[],
		components: {

		},
		computed: {
			...mapState({

			}),
		},
		methods: {
			...mapActions([
				
			]),
			async initData(){

			},
			alert({title,content,onOk,onCancel}){
				this.inlineTitle = title
				this.content = content
				this.onOk = onOk
				this.onCancel = onCancel
				this.type = 'alert'
				this.$emit('input',true)
				this.visiable = true
			},
			confirm({title,content,onOk,onCancel}){
				this.inlineTitle = title
				this.content = content
				this.onOk = onOk
				this.onCancel = onCancel
				this.type = 'confirm'
				this.$emit('input',true)
				this.visiable = true
			},
			makeSure(){
				this.$emit('input',false)
				this.visiable = false
				if (this.onOk) {
					this.onOk()
				}
			},
			close(){
				this.$emit('input',false)
				this.visiable = false
				if (this.onCancel) {
					this.onCancel()
				}
			},
		},
	}
</script>

<style lang='scss' scoped>
	.modal-container {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		z-index: 9999;
		background-color: rgba(0,0,0,0.3);
		display: flex;
		justify-content: center;
		.modal-content {
			position: fixed;
			border-radius: 4px;
			min-width: 400px;
			min-height: 260px;
			display: flex;
			flex-direction: column;
			top: 100px;
			background-color: #fff;
			.title {
				font-size: 15px;
				padding: 10px;
				border-bottom: 1px solid #eee;
			}
			.content {
				flex:1;
			}
			.footer {
				min-height: 40px;
				display: flex;
				flex-direction: row;
				justify-content: flex-end;
				border-top: 1px solid #eee;
			}
		}
	}
	.button {
		font-size: 15px;
		line-height: 30px;
		display: block;
		background-color: #ccc;
		padding:0 20px;
		margin: 5px 20px;
		border-radius: 4px;
		cursor: pointer;
	}
	.fade-enter-active, .fade-leave-active {
		transition: opacity .5s;
	}
	.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
		opacity: 0;
	}
</style>